module.exports = __webpack_public_path__ + "static/media/037 SCS top day.c0cbc4d0.jpg";